import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { getProductOriginsActionAsync } from '../redux/actions/productOriginsActions'

export const useProductOrigins = () => {
  const { productOriginsState } = useSelector(
    (state: RootState) => state.productOrigin
  )
  const dispatch = useDispatch()

  const getProductOrigins = () => {
    dispatch(getProductOriginsActionAsync())
  }

  return { productOriginsState, getProductOrigins }
}
